/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FacilityRegionFacility
 */
export interface FacilityRegionFacility {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the FacilityRegionFacility interface.
 */
export function instanceOfFacilityRegionFacility(value: object): value is FacilityRegionFacility {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FacilityRegionFacilityFromJSON(json: any): FacilityRegionFacility {
    return FacilityRegionFacilityFromJSONTyped(json, false);
}

export function FacilityRegionFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityRegionFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FacilityRegionFacilityToJSON(json: any): FacilityRegionFacility {
    return FacilityRegionFacilityToJSONTyped(json, false);
}

export function FacilityRegionFacilityToJSONTyped(value?: FacilityRegionFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

